require("./global/global");
require("malihu-custom-scrollbar-plugin");
// require("./elements/calculator");
require("./main/index");